import React, { useEffect, useState } from 'react';
import useMediaQuery from '../../hooks/useMediaQuery';
import CustomFilterTable from '../../components/CustomFilterTable/CustomFilterTable';
import CustomPagination from '../../components/CustomPagination/CustomPagination';
import CustomTable from '../../components/CustomTable/CustomTable';
import LoadingTable from '../../components/LoadingTable/LoadingTable';
import useContabilizzazioni from '../../hooks/useContabilizzazioni';
import useContabilizzazioniConfigTable from '../../configTable/useContabilizzazioniConfigTable';

const ContabilizzazioniPage = () => {
  const isWideScreen = useMediaQuery('(min-width: 1200px)');
  const { getContabilizzazioniByParams } = useContabilizzazioni();
  
  const [contabilizzazioni, setContabilizzazioni] = useState([]);
  const [orderBy, setOrderBy] = useState('data_fattura');
  const [orderType, setOrderType] = useState('desc');
  const [selectedPage, setSelectedPage] = useState(1);
  const [formDataFilter, setFormDataFilter] = useState({});
  const [totalPages, setTotalPages] = useState(1);
  const [isLoadingContabilizzazioni, setIsLoadingContabilizzazioni] = useState(false);
  const contabilizzazioniColumns = useContabilizzazioniConfigTable();
  
  useEffect(() => {
    fetchContabilizzazioni();
  }, [orderBy, orderType, selectedPage]);
  
  const fetchContabilizzazioni = async () => {
    setIsLoadingContabilizzazioni(true);
    const obj = {
      filtri: {
        ...formDataFilter
      },
      limite: 10,
      pagina: selectedPage,
      ordinamento: `${orderBy} ${orderType}`
    };
    
    try {
      const response = await getContabilizzazioniByParams(obj);
      setContabilizzazioni(response.data);
      setTotalPages(Math.ceil(response.count / obj.limite));
    } catch (error) {
      console.error("Errore nel recupero delle contabilizzazioni:", error);
    } finally {
      setIsLoadingContabilizzazioni(false);
    }
  };
  
  const onFilteredTable = async () => {
    setSelectedPage(1);
    await fetchContabilizzazioni();
  };
  
  const handleOrder = (newOrderBy, newOrderType) => {
    setOrderBy(newOrderBy);
    setOrderType(newOrderType);
  };
  
  const handlePageChange = (page) => {
    setSelectedPage(page);
  };
  
  return (
    <div className={`card custom-card w-100 shadow ${isWideScreen ? 'p-5' : 'px-1 py-3'}`}>
      <div className='container'>
        <div className='d-flex justify-content-between custom-card-header'>
          <div className='d-flex gap-3 custom-card-title my-2'>
            <div className={`custom-icon-container`}>
              <i className={`bi custom-icon bi-calculator fs-2`}></i>
            </div>
            <div className='align-self-center'>
              <span className='fs-4 d-block'><i><b>Contabilizzazioni</b></i></span>
            </div>
          </div>
        </div>
        
        <div className='mt-5'>
          <CustomFilterTable 
            formDataFilter={formDataFilter}
            setFormDataFilter={setFormDataFilter}
            onFilteredTable={onFilteredTable}
            isLoadingData={isLoadingContabilizzazioni}
            searchNodeType={[
              {nodeType: "input", name: "numero_fattura", placeholder: "Numero fattura"}
            ]}
          />
        </div>

        {isLoadingContabilizzazioni ? (
          <LoadingTable loadingCol={3} />
        ) : (
          <>
            {contabilizzazioni?.length === 0 ? (
              <div className='mt-5 pt-5 text-center'>
                <p>Non ci sono contabilizzazioni da mostrare.</p>
              </div>
            ) : (
              <>
                <CustomTable
                  data={contabilizzazioni}
                  columns={contabilizzazioniColumns}
                  handleOrder={handleOrder}
                  orderBy={orderBy}
                  orderType={orderType}
                />
                <div className="d-flex justify-content-end mt-1">
                  <CustomPagination
                    totalPages={totalPages}
                    selectedPage={selectedPage}
                    handlePageChange={handlePageChange}
                  />
                </div>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default ContabilizzazioniPage;
